<template>
  <div class="step2-wrapper">
    <div class="header">
      <label class="title">设置自动回复</label>
      <p class="tip">请在您的公众号中将此链接设置为关键词<br />【听课】的自动回复内容。裂变出的用户将<br />通过此链接到您的公众号领取课程。</p>
    </div>

    <div class="copy">
      <div class="link">{{link}}</div>
      <span class="btn" @click="copy">复制</span>
    </div>

    <img class="tip-image" src="../../assets/copy-tip.png" />

    <div class="next" @click="next">设置完成，并进入下一步</div>
  </div>
</template>

<script>
export default {
  name: 'step2',
  components: {
  },
  data () {
    return {
      link: `${process.env.VUE_APP_H5_DOMAIN}/?appId=${process.env.VUE_APP_H5_ID}&key=${this.globalData.unlockKey}`,
    }
  },
  async mounted () {

  },
  methods: {
    copy: function () {
      this.$copyText(this.link).then(() => {
        this.$toast('链接复制成功')
      }, () => {
        this.$toast('链接复制失败，请刷新后重试！')
      })
    },
    next: function () {
      this.$router.push('/step3/')
    },
  },
};
</script>

<style src="./index.scss" lang="scss"></style>
